import React, { useState } from 'react';
import { Box, Grid } from '@mui/material/';


export default function Footer() {
  
  
  return (
             
         <div className="Footer">
                     <Grid container justifyContent="center"    alignItems="center" m={2} style={{ borderTop: '1px solid grey'}}>                                                        
                                                    
                        <Grid item  m={2}  >                              
                            <a href="https://opti-jeunesse.org/politique-de-confidentialite/" target="_blank" >Politique de confidentialité</a>
                        </Grid> 

                    </Grid> 
         </div>  
           

                   
            
  );
}

